/**
 * The app's navigation, in one place.
 *
 * `Layout` renders this and `App` mounts a `<Route>` per entry, so the two
 * cannot disagree about what exists -- `routing.test.tsx` pins that. Adding a
 * page means adding one entry here and one `<Route>`; forgetting the route
 * gives a nav link that renders the not-found page, which is exactly what the
 * test catches.
 */
export interface NavEntry {
  to: string;
  label: string;
  /** The bottom bar's icon on a phone; desktop tabs are text only. */
  icon: "credits" | "points" | "bilt" | "cards" | "offers" | "travel";
}

// Credits is home because it holds the deadlines. Which card and Cards are
// one page: the fee table and the card tiles showed the same numbers twice.
// Settings is not a tab; it sits behind the gear in the header. (2026-09-10)
// "Bilt", not "Bilt Cash", so the tabs fit a 360px bottom bar. (2026-09-11)
// Travel is the sixth, at 60px a tab. (2026-09-13)
// Offers sits beside Points because the two are now one habit: both are fed by
// the same browser capture, in the same run, off the same signed-in session on
// each issuer. Reading a balance and reviewing that card's offers happen in one
// sitting, so the tabs for them are adjacent. (2026-09-29)
export const NAV: readonly NavEntry[] = [
  { to: "/", label: "Credits", icon: "credits" },
  { to: "/points", label: "Points", icon: "points" },
  { to: "/offers", label: "Offers", icon: "offers" },
  { to: "/bilt-cash", label: "Bilt", icon: "bilt" },
  { to: "/cards", label: "Cards", icon: "cards" },
  { to: "/travel", label: "Travel", icon: "travel" },
];
